import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Two apps in one build: Studio for the team, and the client review space on
// content.personally.team (or any address with ?akkoord). Each is its own
// chunk, so a client never downloads Studio's code.
const isPortal = window.location.hostname.startsWith('content.') || new URLSearchParams(window.location.search).has('akkoord');
const Root = isPortal ? lazy(() => import('./Portal.jsx')) : lazy(() => import('./App.jsx'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <Root />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
